import { BaseProjectCommand } from './base-project-command.model';

export class UpdateProjectCommand extends BaseProjectCommand {
    id: string;
    asCommunityManager: boolean = false;
    asOrganizationLeader: boolean = false;
    asAdmin: boolean = false;
    asProjectOwner: boolean = false;
}
